import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { EndPoints } from 'src/app/shared/enums';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  loginService(loginObj:any) {
    //return this._cS.API_POST(EndPoints.Login+`?email=${loginObj.email}&password${loginObj.password}`);
    return this._cS.API_POST(EndPoints.Login,loginObj);
  }
  constructor(private _cS : CommonService) { }
}
